export class OfferPrice {
  currencyCodeIso4217: string;
  isFixedPrice: boolean;
  offerPriceGross: number;
}
